import InfoBlock from "./infoBlock";

export default InfoBlock;
